module.exports = __webpack_public_path__ + "static/media/maternity.c9ebc189.svg";